import { render, staticRenderFns } from "./answerHistory.vue?vue&type=template&id=0a2e2367"
import script from "./answerHistory.vue?vue&type=script&lang=js"
export * from "./answerHistory.vue?vue&type=script&lang=js"
import style0 from "./answerHistory.vue?vue&type=style&index=0&id=0a2e2367&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports